import { render, staticRenderFns } from "./HousemateGroupManage.vue?vue&type=template&id=1bedbf26"
import script from "./HousemateGroupManage.vue?vue&type=script&lang=js"
export * from "./HousemateGroupManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports